<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto" v-if="isVerticalMenuCollapsed">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo" style="font-weight: 600;font-size: 16px;">
                ECA
                <!-- <b-img :src="appLogoImage" alt="logo" /> -->
                <!-- {{ appName }} -->
              </span>
              <!-- <h2 class="brand-text">
                ECA
              </h2> -->
            </b-link>
          </li>
          <li class="nav-item mr-auto" v-else>
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <!-- <b-img :src="appLogoImage" alt="logo" /> -->
                <!-- {{ appName }} -->
              </span>
              <h2 class="brand-text">
                ECloudAccess
              </h2>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems1"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import navMenuItems from "@/navigation/vertical";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  data() {
    return {
      navMenuItems1: [
        {
          title: "Applications",
          route: "home",
          icon: "HomeIcon",
          is_allowed: "true",
        },
        {
          title: "Cloud Profiles",
          route: "ecacloud",
          icon: "CloudIcon",
           is_allowed: this.$store.state.app.user.groups[0].name == 'Admin',
          // is_allowed: this.$store.state.app.user.is_staff,
        },
        {
          title: "Firewalls",
          route: "ecafirewall",
          icon: "ServerIcon",
           is_allowed: this.$store.state.app.user.groups[0].name == 'Admin',
          // is_allowed: this.$store.state.app.user.permissions.includes('firewall.list_firewall'),
        },
         {
          title: "Users",
          route: "ecauser",
          icon: "UserIcon",
          is_allowed: this.$store.state.app.user.groups[0].name == 'Admin',
          
        },
        {
          title: "Roles",
          route: "ecaroles",
          icon: "AwardIcon",
           is_allowed: this.$store.state.app.user.groups[0].name == 'Admin',
          // is_allowed: this.$store.state.app.user.is_staff,
        },  
        {
          title: "Logs",
          route: "ecalog",
          icon: "TargetIcon",
          is_allowed: this.$store.state.app.user.groups[0].name == 'Admin',
          // is_allowed: this.$store.state.app.user.is_staff,
        },
        // {
        //   title: "Users",
        //   route: "Users",
        //   icon: "UserIcon",
        //   is_allowed: this.$store.state.app.user.is_staff,
        // },

        // {
        //   title: "Roles",
        //   route: "Roles",
        //   icon: "AwardIcon",
        //   is_allowed: this.$store.state.app.user.is_staff,
        // },

        // {
        //   title: "Vulnerability Database",
        //   route: "eca",
        //   icon: "DatabaseIcon",
        //   is_allowed: this.$store.state.app.user.is_staff,
        // },
        // {
        //   title: "OWASP Top 10",
        //   route: "owasp_list",
        //   icon: "BookIcon",
        //   is_allowed: this.$store.state.app.user.is_staff,
        // },
      ],
    };
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
